package com.appcreator.creatorapp

enum class Navigation(val route: String) {
    Root("/"),
    Organisations("organisations"),
    Projects("projects"),
    Blueprints("blueprints"),
    Preview("preview")
}